import { site } from "@/mocks/site";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Testimonials() {
  return (
    <section className="border-y border-background-200 bg-background-100" aria-labelledby="voice-heading">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16">
        <div id="voice-heading">
          <SectionHeading
            eyebrow="读者反馈"
            title="他们说，这样看信息更踏实"
            desc="下面这些反馈来自长期使用档案库的读者与从业者，仅代表个人观点。"
          />
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {site.testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-400" aria-hidden="true"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-700">
                  {item.name.slice(-2, -1)}
                </span>
                <span>
                  <span className="block font-heading text-[13px] font-bold text-foreground-950">{item.name}</span>
                  <span className="block font-label text-[11px] text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}